<ng-container *ngIf="numberValue !== undefined && format !== undefined">
	<span>{{ numberFormatted }}</span><span [class.copo-numeric-cell-hidden]="format !== 'weight-with-zero' || !numberFormatted">{{ numberValue | copoHiddenNumber:format }}</span>
</ng-container>